import React, { useState, useEffect } from 'react';
import Footer from '../../layout/Footer';
import ViewRoles from './ViewRoles';
import { Container, Row, Col, Card, Form, Nav } from 'react-bootstrap';
import SimpleBarReact from "simplebar-react";

import DesignationData from "./designation-data.json";

// Icon
import Icon from '@mdi/react';
import { mdiFormatListBulletedSquare, mdiPlus, mdiMagnify } from '@mdi/js';
import FormInputs from '../../../Utils/FormInputs';

export default function Designation() {
    // left navlink active
    useEffect(() => {
        var a = document.getElementsByClassName("left-link-item");
        for (var i = 0; i < a.length; i++) {
            a[i].onclick = function () {
                var b = document.querySelector(".left-link-item a.active");
                if (b) b.classList.remove("active");
                this.children[0].classList.add('active');
            };
        }
    }, []);
    const [designationListData] = useState(DesignationData);

    const initialInputData = {
        rolesName: '',
    };
    const [inputData, setInputData] = useState({ ...initialInputData });
    const handleNewRoleInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleNewRoleSubmit = (e) => {
        e.preventDefault();
    };
    const newRoleRows = [
        {
            columns: [
                { size: { md: 12 }, label: 'Roles Name', type: 'text', placeholder: 'Enter roles name...', name: 'rolesName', id: 'rolesName', value: inputData.rolesName, errormsg: '', },
            ],
        },
    ];
    const newRoleButtons = [
        { variant: "primary", text: "Add", onClick: handleNewRoleSubmit },
        { variant: "secondary", text: "Cancel" },
    ];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className='d-md-flex justify-content-between align-items-center'>
                                            <Form className='custom-form-width'>
                                                <div className='custom-search-bar'>
                                                    <Icon path={mdiMagnify} size={1} className="custom-search-input-icon" />
                                                    <Form.Control className='' type="text" placeholder="Search branch..." name='branchSearch' id='branchSearch' />
                                                </div>
                                            </Form>
                                            <div className="custom-top-nav-tab mt-3 mt-md-0">
                                                <ul className="nav nav-pills btn-list" id="pills-tab" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link active" id="pills-view-roles-tab" data-bs-toggle="pill" data-bs-target="#pills-view-roles" type="button" role="tab" aria-controls="pills-view-roles" aria-selected="true">
                                                            <Icon path={mdiFormatListBulletedSquare} className="btn-icon me-1" />View Roles
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className="nav-link" id="pills-new-roles-tab" data-bs-toggle="pill" data-bs-target="#pills-new-roles" type="button" role="tab" aria-controls="pills-new-roles" aria-selected="false">
                                                            <Icon path={mdiPlus} className="btn-icon me-1" />New Roles
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={4} xxl={3}>
                                <Card className='procust-left-list leftbar-list'>
                                    <SimpleBarReact>
                                        <Card.Body>
                                            <div className='left-list-bar'>
                                                {designationListData.designationlist.map((data, i) =>
                                                    <Nav.Item className='left-link-item' key={i}>
                                                        <Nav.Link className={i === 0 ? "active" : ""}>
                                                            <h5 className='product-tab-title'>{data.designationLink}</h5>
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                )}
                                            </div>
                                        </Card.Body>
                                    </SimpleBarReact>
                                </Card>
                            </Col>
                            <Col lg={8} xxl={9}>

                                <div className="tab-content custom-top-nav-tab" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-view-roles" role="tabpanel" aria-labelledby="pills-view-roles-tab" tabIndex="0">
                                        <ViewRoles />
                                    </div>
                                    <div className="tab-pane fade" id="pills-new-roles" role="tabpanel" aria-labelledby="pills-new-roles-tab" tabIndex="0">
                                        <Card className='right-content-details'>
                                            <Card.Body>
                                                <Card.Title>New Roles</Card.Title>
                                                <FormInputs Buttons={newRoleButtons} rows={newRoleRows} handleInputChange={handleNewRoleInputChange} handleSubmit={handleNewRoleSubmit} />
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
